import React from 'react';
import './UserProfileCard.css';
import Avatar from '../widgets/Avatar';
import {Link} from 'react-router-dom';
import OptionsButton from '../widgets/OptionsButton';

const UserProfileCard = ({profile, options, children}) => {
	if (!profile || !profile.user || !profile.profile || profile.subscriptionLevel !== 'none')
		return null;

	return (
		<li className="UserProfileCard">
			<Link to={`/@${profile.profile.uniqueName}`}>
				{options && <OptionsButton className="ProfileCard-options" options={options} />}
				<Avatar provider={profile} size={48} />
				<div className="UserProfileCard-detail">
					<div className="UserProfileCard-name">
						{profile.user.firstname} {profile.user.lastname}
					</div>
					<div className="UserProfileCard-location">
						<span className="icon-room" />
						<span>{profile.user.location.suburb}</span>
					</div>
				</div>
			</Link>
			{children}
		</li>
	);
};

export default UserProfileCard;



// WEBPACK FOOTER //
// ./src/profile/UserProfileCard.js